import { render, staticRenderFns } from "./AvailableLabours.vue?vue&type=template&id=79d50732&scoped=true"
import script from "./AvailableLabours.vue?vue&type=script&lang=js"
export * from "./AvailableLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d50732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d50732')) {
      api.createRecord('79d50732', component.options)
    } else {
      api.reload('79d50732', component.options)
    }
    module.hot.accept("./AvailableLabours.vue?vue&type=template&id=79d50732&scoped=true", function () {
      api.rerender('79d50732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableLabours.vue"
export default component.exports